import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NewQuizAndItemAnalysisReportCardPresenter;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import Card from '../../../../../common/components/shared/Card';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import AnalysisMetric from '../AnalysisMetric';
import Spinner from '../../../../../common/components/shared/spinner/Spinner';
import { AnalysisUpdateDate } from '../../common/AnalysisUpdateDate';
import { itemAnalysisPropType, quizAnalysisPropType } from '../../common/propTypes';
import { csvFormat } from '../exportFormats';
import { ExportButton } from '../ExportButton';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var NewQuizAndItemAnalysisReportCardPresenter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NewQuizAndItemAnalysisReportCardPresenter = /*#__PURE__*/function (_Component) {
  function NewQuizAndItemAnalysisReportCardPresenter() {
    var _this2;
    _classCallCheck(this, NewQuizAndItemAnalysisReportCardPresenter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, NewQuizAndItemAnalysisReportCardPresenter, [].concat(args));
    _defineProperty(_this2, "handleGeneration", function (_event) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'last_attempt';
      _this2.props.generateReports(filter);
    });
    _defineProperty(_this2, "handleExport", function (_event) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : csvFormat;
      var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'last_attempt';
      _this2.props.exportReports(format, filter);
    });
    _defineProperty(_this2, "renderMetrics", function () {
      var _quizAnalysis$scores, _quizAnalysis$scores2, _quizAnalysis$scores3;
      var quizAnalysis = _this2.props.quizAnalysis;
      return jsx("div", {
        css: _this2.props.styles.metricsContainer
      }, jsx(AnalysisMetric, {
        metricKey: "highscore",
        label: t('High Score'),
        value: (_quizAnalysis$scores = quizAnalysis.scores) === null || _quizAnalysis$scores === void 0 ? void 0 : _quizAnalysis$scores.max_percentage,
        suffix: "%"
      }), jsx(AnalysisMetric, {
        metricKey: "lowscore",
        label: t('Low Score'),
        value: (_quizAnalysis$scores2 = quizAnalysis.scores) === null || _quizAnalysis$scores2 === void 0 ? void 0 : _quizAnalysis$scores2.min_percentage,
        suffix: "%"
      }), jsx(AnalysisMetric, {
        metricKey: "meanscore",
        label: t('Mean Score'),
        value: (_quizAnalysis$scores3 = quizAnalysis.scores) === null || _quizAnalysis$scores3 === void 0 ? void 0 : _quizAnalysis$scores3.mean_percentage,
        suffix: "%"
      }));
    });
    _defineProperty(_this2, "renderQuizAnalysisSummary", function () {
      var _this2$props = _this2.props,
        quizAnalysis = _this2$props.quizAnalysis,
        itemAnalyses = _this2$props.itemAnalyses,
        href = _this2$props.href;
      return jsx("div", {
        css: _this2.props.styles.quizAnalysisSummary
      }, _this2.renderMetrics(), jsx(Flex, {
        direction: "row",
        justifyItems: "space-between"
      }, jsx("div", {
        css: _this2.props.styles.dateContainer
      }, jsx(AnalysisUpdateDate, {
        date: quizAnalysis.created_timestamp,
        multiline: true
      })), quizAnalysis && itemAnalyses && jsx(Link, {
        href: href,
        "data-automation": "sdk-new-ia-report-card-view-report-button"
      }, jsx(ScreenReaderContent, null, t('View Quiz and Item Analysis Report')), jsx(Text, {
        size: "small",
        "aria-hidden": "true"
      }, t('View Report')))));
    });
    _defineProperty(_this2, "renderSpinner", function (mainText) {
      return jsx("div", {
        css: _this2.props.styles.emptyCardBodyContainer
      }, jsx(Flex, {
        direction: "row"
      }, jsx(Flex.Item, null, jsx(Spinner, {
        size: "x-small",
        color: "brand",
        minHeight: "0",
        mainText: mainText,
        fontSize: "x-small",
        "data-automation": "sdk-new-ia-report-card-spinner"
      }))));
    });
    _defineProperty(_this2, "renderGenerateReportButton", function () {
      return jsx(Link, {
        onClick: _this2.handleGeneration,
        role: "button",
        "data-automation": "sdk-new-ia-report-card-generate-report-button"
      }, jsx(ScreenReaderContent, null, t('Generate Quiz and Item Analysis Report')), jsx(Text, {
        size: "small",
        "aria-hidden": "true"
      }, t('Generate Report')));
    });
    _defineProperty(_this2, "renderReportCardFooter", function () {
      var _this2$props2 = _this2.props,
        generationInProgress = _this2$props2.generationInProgress,
        analysisError = _this2$props2.analysisError;
      return jsx("div", {
        css: _this2.props.styles.emptyCardBodyContainer
      }, jsx(Flex, {
        direction: "row",
        justifyItems: "space-between"
      }, jsx(Flex.Item, {
        shouldShrink: true,
        size: analysisError && !generationInProgress ? '40%' : null
      }, analysisError && !generationInProgress && jsx(Text, {
        size: "x-small",
        weight: "bold",
        color: "danger"
      }, analysisError)), jsx(Flex.Item, {
        shouldShrink: analysisError && !generationInProgress
      }, generationInProgress ? _this2.renderSpinner(t('Generation In Progress')) : _this2.renderGenerateReportButton())));
    });
    _defineProperty(_this2, "renderExport", function () {
      var _this2$props3 = _this2.props,
        quizAnalysis = _this2$props3.quizAnalysis,
        generationInProgress = _this2$props3.generationInProgress;
      return jsx(ExportButton, {
        quizAnalysis: quizAnalysis,
        generationInProgress: generationInProgress,
        handleExport: _this2.handleExport
      });
    });
    _defineProperty(_this2, "renderReportCardHeader", function () {
      var _this2$props4 = _this2.props,
        name = _this2$props4.name,
        exportEnabled = _this2$props4.exportEnabled,
        fetchInProgress = _this2$props4.fetchInProgress;
      return jsx("div", {
        css: _this2.props.styles.titleContainer
      }, jsx(Flex, {
        direction: "row",
        wrap: "wrap",
        justifyItems: "space-between"
      }, jsx(Flex.Item, null, jsx(Text, {
        size: "medium",
        weight: "bold"
      }, name)), exportEnabled && !fetchInProgress && jsx(Flex.Item, null, _this2.renderExport())));
    });
    return _this2;
  }
  _inherits(NewQuizAndItemAnalysisReportCardPresenter, _Component);
  return _createClass(NewQuizAndItemAnalysisReportCardPresenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fetchInProgress = _this$props.fetchInProgress,
        quizAnalysis = _this$props.quizAnalysis,
        styles = _this$props.styles;
      return jsx(Card, {
        css: styles.reportCard,
        customStyles: styles.reportCard
      }, this.renderReportCardHeader(), !fetchInProgress && quizAnalysis && this.renderQuizAnalysisSummary(), fetchInProgress && this.renderSpinner(), !fetchInProgress && this.renderReportCardFooter());
    }
  }]);
}(Component), _defineProperty(_NewQuizAndItemAnalysisReportCardPresenter, "displayName", 'NewQuizAndItemAnalysisReportCardPresenter'), _defineProperty(_NewQuizAndItemAnalysisReportCardPresenter, "componentId", "Quizzes".concat(_NewQuizAndItemAnalysisReportCardPresenter.displayName)), _defineProperty(_NewQuizAndItemAnalysisReportCardPresenter, "propTypes", {
  name: PropTypes.node,
  href: PropTypes.string,
  quizAnalysis: quizAnalysisPropType,
  itemAnalyses: PropTypes.arrayOf(itemAnalysisPropType),
  fetchInProgress: PropTypes.bool.isRequired,
  generationInProgress: PropTypes.bool.isRequired,
  analysisError: PropTypes.string,
  generateReports: PropTypes.func.isRequired,
  exportReports: PropTypes.func.isRequired,
  exportEnabled: PropTypes.bool.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_NewQuizAndItemAnalysisReportCardPresenter, "defaultProps", {
  name: void 0,
  href: void 0,
  analysisError: void 0,
  generationInProgress: void 0,
  quizAnalysis: void 0,
  itemAnalyses: void 0
}), _NewQuizAndItemAnalysisReportCardPresenter)) || _class);